import React from 'react';
import RoleSuccessPage from '../RoleManagement/RoleSuccessPage';
import { ROLE_CONFIGS } from '../RoleManagement/roleConfig';
import styles from './DistributorSuccessPage.module.css';
import qrCode from '../../assets/images/qr-admin.png';

const DistributorSuccessPage: React.FC = () => (
  <RoleSuccessPage config={ROLE_CONFIGS.distributor} styles={styles} staticQrImage={qrCode} />
);

export default DistributorSuccessPage;
